import api from '../http';
import { AxiosResponse } from 'axios';
import { User } from '../models/user';


export default class UserService {
    static async get(): Promise<AxiosResponse<User>> {
        return await api.get('user');
    };
};